import { type FC } from 'react';
import classnames from 'classnames';
import { PapiGallection } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import FoldersHeader from '../FoldersHeader';
import FolderSlider from '../FolderSlider';
import FolderContent from '../FolderContent';
import GalleryTierUpsellCard from '../GalleryUpsellCard';
import { useGalleryUpsell } from '../hooks/useGalleryUpsell';

import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder?: PapiGallection;
  hideFolderSlider?: boolean;
}

const DesktopGallectionSimpleView: FC<Props> = ({ currentFolder, hideFolderSlider }) => {
  const { showPromo, promoType, promoDeviation, promoCount } = useGalleryUpsell();

  const renderSliderArea = () => {
    return (
      <div className={classnames(s['folders-and-ad'], hideFolderSlider && s['no-slider'])}>
        <FoldersHeader />
        <div className={s['slider-row']}>
          {!hideFolderSlider && <FolderSlider />}
          {showPromo && !hideFolderSlider && (
            <GalleryTierUpsellCard
              promoType={promoType}
              promoCount={promoCount}
              promoDeviation={promoDeviation}
            />
          )}
        </div>
      </div>
    );
  };
  return (
    <div id="content" className={s['root']}>
      <ErrorBoundary debugComponent="DesktopGallectionSimpleView">
        {renderSliderArea()}
        <div id="sub-folder-gallery">
          {currentFolder && (
            <FolderContent key={currentFolder?.folderId} folderId={currentFolder?.folderId || 0} />
          )}
        </div>
      </ErrorBoundary>
    </div>
  );
};
DesktopGallectionSimpleView.displayName = 'DesktopGallectionSimpleView';

export default DesktopGallectionSimpleView;
